import { render, staticRenderFns } from "./eventGroup.vue?vue&type=template&id=483d3fd6&scoped=true&"
import script from "./eventGroup.vue?vue&type=script&lang=js&"
export * from "./eventGroup.vue?vue&type=script&lang=js&"
import style0 from "./eventGroup.vue?vue&type=style&index=0&id=483d3fd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483d3fd6",
  null
  
)

export default component.exports